import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[festival-slug]/[locale]/(rest)/awards/components/AwardedFilm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/blocks/AwardsSection.tsx");
